export default "__VITE_ASSET__NIGhQIei__"